import { render, staticRenderFns } from "./Co_together.vue?vue&type=template&id=01fbe7a3&scoped=true"
import script from "./Co_together.vue?vue&type=script&lang=js"
export * from "./Co_together.vue?vue&type=script&lang=js"
import style0 from "./Co_together.vue?vue&type=style&index=0&id=01fbe7a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbe7a3",
  null
  
)

export default component.exports